import { estadoCivilPessoaFisicaOptions } from "./dynamicTextRegistry";

const showConjugeWhenCasado = {
  field: "ESTADO_CIVIL_PESSOA_FISICA",
  value: "casado",
};

const pessoaFisicaFields = [
  { id: "NOME_PESSOA_FISICA", label: "Nome", type: "text", required: true },
  {
    id: "CPF_PESSOA_FISICA",
    label: "CPF",
    type: "text",
    required: true,
    mask: "cpf",
  },
  { id: "RG_PESSOA_FISICA", label: "RG", type: "text" },
  { id: "NACIONALIDADE_PESSOA_FISICA", label: "Nacionalidade", type: "text" },
  { id: "PROFISSAO_PESSOA_FISICA", label: "Profissão", type: "text" },
  {
    id: "ESTADO_CIVIL_PESSOA_FISICA",
    label: "Estado civil",
    type: "select",
    required: true,
    options: estadoCivilPessoaFisicaOptions,
    placeholder: "Selecione",
  },
  {
    id: "NOME_CONJUGE",
    label: "Nome do cônjuge",
    type: "text",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "CPF_CONJUGE",
    label: "CPF do cônjuge",
    type: "text",
    mask: "cpf",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "RG_CONJUGE",
    label: "RG do cônjuge",
    type: "text",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "NACIONALIDADE_CONJUGE",
    label: "Nacionalidade do cônjuge",
    type: "text",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "PROFISSAO_CONJUGE",
    label: "Profissão do cônjuge",
    type: "text",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "EMAIL_CONJUGE",
    label: "E-mail do cônjuge",
    type: "email",
    required: true,
    showWhen: showConjugeWhenCasado,
  },
  { id: "RUA_ENDERECO_PESSOA_FISICA", label: "Rua", type: "text" },
  { id: "N_ENDERECO_PESSOA_FISICA", label: "Número", type: "text" },
  { id: "BAIRRO_ENDERECO_PESSOA_FISICA", label: "Bairro", type: "text" },
  { id: "MUN_ENDERECO_PESSOA_FISICA", label: "Município", type: "text" },
  { id: "CEP_PESSOA_FISICA", label: "CEP", type: "text" },
  { id: "EMAIL_PESSOA_FISICA", label: "Email", type: "email", required: true },
  {
    id: "TEL_PESSOA_FISICA",
    label: "Telefone",
    type: "text",
    mask: "phone",
  },
];

const autorizacaoGlebaLoteamentoFormSchema = [
  {
    sectionId: "proprietarios",
    sectionLabel: "Autorizadores (proprietários)",
    repeatable: true,
    groupKey: "proprietarios",
    minItems: 1,
    fields: [...pessoaFisicaFields],
  },

  {
    sectionId: "intermediador",
    sectionLabel: "Autorizado (intermediador)",
    type: "conditional",
    groupKey: "intermediador",
    requireTypeSelection: true,
    options: {
      corretor: [
        {
          id: "NOME_CORRETOR",
          label: "Nome do corretor",
          type: "text",
          required: true,
        },
        {
          id: "NACIONALIDADE_CORRETOR",
          label: "Nacionalidade",
          type: "text",
          required: true,
        },
        {
          id: "CPF_CORRETOR",
          label: "CPF",
          type: "text",
          required: true,
          mask: "cpf",
        },
        { id: "RG_CORRETOR", label: "RG", type: "text", required: true },
        {
          id: "CRECI_CORRETOR",
          label: "CRECI",
          type: "text",
          required: true,
        },
        {
          id: "RUA_ENDERECO_CORRETOR",
          label: "Rua",
          type: "text",
          required: true,
        },
        {
          id: "N_ENDERECO_CORRETOR",
          label: "Número",
          type: "text",
          required: true,
        },
        {
          id: "BAIRRO_ENDERECO_CORRETOR",
          label: "Bairro",
          type: "text",
          required: true,
        },
        {
          id: "MUN_ENDERECO_CORRETOR",
          label: "Município",
          type: "text",
          required: true,
        },
        {
          id: "CEP_CORRETOR",
          label: "CEP",
          type: "text",
          required: true,
        },
        {
          id: "EMAIL_CORRETOR",
          label: "E-mail",
          type: "email",
          required: true,
        },
        {
          id: "TEL_CORRETOR",
          label: "Telefone",
          type: "text",
          required: true,
          mask: "phone",
        },
      ],
      imobiliaria: [
        {
          id: "RAZAO_SOCIAL_IMOBILIARIA",
          label: "Razão social",
          type: "text",
          required: true,
        },
        {
          id: "CNPJ_IMOBILIARIA",
          label: "CNPJ",
          type: "text",
          required: true,
        },
        {
          id: "INTERM_CRECI_IMOBILIARIA",
          label: "CRECI (autorizado)",
          type: "text",
          required: true,
        },
        {
          id: "NOME_REPRESENTANTE_LEGAL",
          label: "Representante legal",
          type: "text",
          required: true,
        },
        {
          id: "CPF_REPRESENTANTE_LEGAL",
          label: "CPF do representante",
          type: "text",
          required: true,
          mask: "cpf",
        },
        {
          id: "RUA_ENDERECO_IMOBILIARIA",
          label: "Rua",
          type: "text",
          required: true,
        },
        {
          id: "N_ENDERECO_IMOBILIARIA",
          label: "Número",
          type: "text",
          required: true,
        },
        {
          id: "BAIRRO_ENDERECO_IMOBILIARIA",
          label: "Bairro",
          type: "text",
          required: true,
        },
        {
          id: "MUN_ENDERECO_IMOBILIARIA",
          label: "Município",
          type: "text",
          required: true,
        },
        {
          id: "CEP_IMOBILIARIA",
          label: "CEP",
          type: "text",
          required: true,
        },
        {
          id: "INTERM_EMAIL_IMOBILIARIA",
          label: "E-mail (autorizado)",
          type: "email",
          required: true,
        },
        {
          id: "TEL_IMOBILIARIA",
          label: "Telefone",
          type: "text",
          required: true,
          mask: "phone",
        },
      ],
    },
  },

  {
    sectionId: "testemunhas",
    sectionLabel: "Testemunhas",
    repeatable: true,
    groupKey: "testemunhas",
    fields: [
      { id: "NOME_TESTEMUNHA", label: "Nome", type: "text", required: true },
      {
        id: "CPF_TESTEMUNHA",
        label: "CPF",
        type: "text",
        required: true,
        mask: "cpf",
      },
      { id: "EMAIL_TESTEMUNHA", label: "Email", type: "email", required: true },
    ],
  },

  {
    sectionId: "dados-imovel",
    sectionLabel: "Dados do imóvel",
    fields: [
      {
        id: "MATRICULA_IMOVEL",
        label: "Matrícula do imóvel",
        type: "text",
        required: true,
      },
      {
        id: "OFICIO_REGISTRO",
        label: "Ofício de registro",
        type: "text",
        required: true,
      },
      {
        id: "COMARCA_IMOVEL",
        label: "Comarca do imóvel",
        type: "text",
        required: true,
      },
      {
        id: "AREA_IMOVEL_HECTARES",
        label: "Área (hectares)",
        type: "text",
        required: true,
      },
      {
        id: "BAIRRO_IMOVEL",
        label: "Bairro",
        type: "text",
        required: true,
      },
      {
        id: "MUNICIPIO_IMOVEL",
        label: "Município",
        type: "text",
        required: true,
      },
    ],
  },

  {
    sectionId: "dados-autorizacao",
    sectionLabel: "Modalidade, prazo e valores",
    fields: [
      {
        id: "EXCLUSIVIDADE",
        label: "Exclusividade",
        type: "select",
        required: true,
        options: [
          { value: "exclusividade", label: "Exclusividade" },
          { value: "sem_exclusividade", label: "Sem exclusividade" },
        ],
        placeholder: "Selecione",
      },
      {
        id: "PRAZO_AUTORIZACAO",
        label: "Prazo da autorização (meses)",
        type: "number",
        required: true,
        min: 1,
        max: 1000,
        step: 1,
      },
      {
        id: "PERCENTUAL_COMISSAO",
        label: "Comissão (%)",
        type: "text",
        required: true,
        mask: "decimal_br",
      },
      {
        id: "PERCENTUAL_COMISSAO_EXTENSO",
        label: "Comissão por extenso",
        type: "text",
        required: true,
      },
      {
        id: "VALOR_IMOVEL",
        label: "Valor do imóvel (R$)",
        type: "text",
        required: true,
        mask: "brl_currency",
      },
      {
        id: "VALOR_IMOVEL_EXTENSO",
        label: "Valor do imóvel por extenso",
        type: "text",
        required: true,
        extensoOf: "VALOR_IMOVEL",
      },
      {
        id: "COMARCA_FORO",
        label: "Foro (comarca)",
        type: "text",
        required: true,
      },
    ],
  },

  {
    sectionId: "dados-contrato",
    sectionLabel: "Assinatura",
    fields: [
      {
        id: "CIDADE_ASSINATURA",
        label: "Cidade da assinatura",
        type: "text",
      },
      {
        id: "DATA_ASSINATURA",
        label: "Data da assinatura",
        type: "date",
      },
    ],
  },
];

export default autorizacaoGlebaLoteamentoFormSchema;
